/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';

/**
 * The ESPSettingsCustom model module.
 * @module model/ESPSettingsCustom
 * @version 1.0.0
 */
export class ESPSettingsCustom {
  /**
   * Constructs a new <code>ESPSettingsCustom</code>.
   * @alias module:model/ESPSettingsCustom
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ESPSettingsCustom</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ESPSettingsCustom} obj Optional instance to populate.
   * @return {module:model/ESPSettingsCustom} The populated <code>ESPSettingsCustom</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ESPSettingsCustom();
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('value'))
        obj.value = ApiClient.convertToType(data['value'], 'String');
    }
    return obj;
  }
}

/**
 * Allowed values for the <code>name</code> property.
 * @enum {String}
 * @readonly
 */
ESPSettingsCustom.NameEnum = {
  /**
   * value: "ses_region"
   * @const
   */
  region: "ses_region",

  /**
   * value: "ses_config_set"
   * @const
   */
  config_set: "ses_config_set"
};
/**
 * @member {module:model/ESPSettingsCustom.NameEnum} name
 */
ESPSettingsCustom.prototype.name = undefined;

/**
 * @member {String} value
 */
ESPSettingsCustom.prototype.value = undefined;

